/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import { View, StyleSheet, Text, Dimensions } from 'react-native';
import Image from '@web/components/common/Image';
import { Slider } from '@sharcoux/slider';
import { useDispatch, useSelector } from 'react-redux';
const Button = React.lazy(() => import('@web-components/form/Button'));
import Cropper from 'cropperjs/dist/cropper.min.js';
import { Row, Col } from '@universal/layout';
import { isWeb } from '~global/screens';
import '@web/css/cropper.css'; // extends
let cropper = null;

const colPropText = {
  ...(isWeb
    ? {
        xs: 4,
      }
    : {
        md: 12,
        gutterWidth: 0,
      }),
};

const colPropSlider = {
  ...(isWeb
    ? {
        xs: 8,
      }
    : {
        md: 12,
      }),
};

const ImageCrop = forwardRef((props, ref) => {
  const { defaultProductImage } = global;
  const [currentNumberSlider, setCurrentNumberSlider] = useState(0);
  const {
    imageSource,
    sliderText,
    enabledSlider,
    width = 800,
    height = 501,
    isCloseCropper,
    // aspectRatio = 1.91,
    onCrop,
    cropperConfig,
  } = props;
  const modalCropPhotoData = useSelector(
    (state) => state.modal.egiftCropPhoto.data,
  );
  const imageReady =
    imageSource && imageSource.uri ? imageSource.uri : defaultProductImage;
  const dispatch = useDispatch();

  const save = () => {
    const result = cropper.getCroppedCanvas({
      width: width,
      height: height,
    });

    if (result) {
      const image = modalCropPhotoData ? modalCropPhotoData : imageSource;
      const value = {
        uri: result.toDataURL(),
        filename: image.filename,
        type: image.type,
      };
      if (onCrop) {
        onCrop(value);
      } else {
        dispatch({
          type: 'productDetail/setPhotoUploaded',
          value,
        });
      }
    }

    if (!onCrop) {
      dispatch({ type: 'MODAL/HIDE', modalName: 'egiftCropPhoto', data: '' });
    }
    if (cropper) {
      cropper.destroy();
      cropper = null;
    }
  };

  const onSlidingComplete = (number) => {
    const increased = currentNumberSlider < number ? true : false;
    const decreased = currentNumberSlider > number ? true : false;
    const isNotEqual = currentNumberSlider !== number;

    if (increased && isNotEqual) {
      cropper.zoom(0.1);
    }

    if (decreased && isNotEqual) {
      cropper.zoom(-0.1);
    }

    setCurrentNumberSlider(number);
  };

  useImperativeHandle(ref, () => ({
    reset() {
      if (cropper) {
        cropper.destroy();
        cropper = null;
        setCurrentNumberSlider(0);
      }
    },
  }));

  useEffect(() => {
    if (isCloseCropper) {
      if (cropper) {
        cropper.destroy();
        cropper = null;
      }
    }
  }, [isCloseCropper]);
  useEffect(() => {
    if (imageSource && imageSource.uri && !cropper) {
      const image = document.querySelector('#image');
      // cropper = new Cropper(image, {
      //   dragMode: 'move',
      //   zoomable: true,
      //   restore: false,
      //   guides: true,
      //   center: false,
      //   highlight: false,
      //   cropBoxMovable: false,
      //   cropBoxResizable: false,
      //   toggleDragModeOnDblclick: false,
      //   autoCropArea: 1,
      //   aspectRatio: aspectRatio,
      //   viewMode: 3,
      // });
      cropper = new Cropper(image, cropperConfig);
    }
  }, [imageSource]);

  return (
    <View>
      <View style={styles.imageCropper}>
        <View
          style={[
            styles.cropperContainer,
            !isWeb
              ? {
                  height:
                    (Dimensions.get('window').width - 48) /
                    (cropperConfig.aspectRatio || 1),
                }
              : {},
          ]}>
          <img
            src={imageReady}
            style={{ borderRadius: 16 }}
            id="image"
            width="100%"
            height="266"
          />
        </View>
      </View>
      {enabledSlider && (
        <View style={styles.footer}>
          <View style={styles.sliderCotainer}>
            <Row>
              <Col {...colPropText}>
                <Text style={styles.infoText}>{sliderText}</Text>
              </Col>

              <Col {...colPropSlider}>
                <Slider
                  value={currentNumberSlider} // set the current slider's value
                  minimumValue={0} // Minimum value
                  maximumValue={10} // Maximum value
                  step={1} // The step for the slider (0 means that the slider will handle any decimal value within the range [min, max])
                  minimumTrackTintColor="#EF6354" // The track color before the current value
                  maximumTrackTintColor="#E5E5E5" // The track color after the current value
                  thumbTintColor="#EF6354" // The color of the slider's thumb
                  enabled={true} // If false, the slider won't respond to touches anymore
                  trackHeight={4} // The track's height in pixel
                  thumbSize={16} // The thumb's size in pixel
                  slideOnTap={true} // If true, touching the slider will update it's value. No need to slide the thumb.
                  onValueChange={onSlidingComplete}
                />
              </Col>
            </Row>
          </View>

          <View style={{ flexDirection: 'row', flexWrap: 'nowrap' }}>
            <Image
              source={require('~assets/img/e-gift/icon-lamp.png')}
              style={styles.iconLamp}
            />
            <Text style={styles.copywritting}>
              <Text style={styles.copywrittingBolder}>Pro Tip :</Text>Geser foto
              dengan tangan atau dengan zoom bar untuk mengatur posisi foto
            </Text>
          </View>
        </View>
      )}

      <View style={styles.buttonContainer}>
        <Button title="Crop & Save" onPress={() => save()} />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  buttonContainer: {
    marginTop: 40,
    paddingBottom: 24,
    paddingHorizontal: 24,
  },
  copywritting: {
    fontFamily: 'figtree-medium',
    fontSize: 13,
    letterSpacing: 0.2,
    lineHeight: 16,
    color: '#222222',
  },
  copywrittingBolder: {
    fontFamily: 'figtree-bold',
  },
  footer: {
    paddingHorizontal: 24,
    marginTop: 18,
  },
  sliderCotainer: {
    marginBottom: 20,
  },
  iconLamp: {
    width: 15,
    height: 18,
    marginRight: 8,
  },
  infoText: {
    color: '#222222',
    fontSize: 16,
    fontFamily: 'figtree-black',
    lineHeight: 22,
  },
  cropperContainer: {
    borderRadius: 16,
    ...(isWeb
      ? {
          height: 266,
        }
      : {}),
  },
  imageCropper: {
    backgroundColor: '#F8F8F8',
    padding: 16,
    paddingHorizontal: 24,
    position: 'relative',
  },
  slider: {},
});

ImageCrop.displayName = 'ImageCrop';

export default ImageCrop;
